import { styled } from "@mui/material";

interface Page {
    disableCenter?: boolean;
    disablePadding?: boolean;
    table?: boolean;
    product?: boolean;
}

export const Styled = {
    Header: styled("div")`
    `,
    Main: styled("div")<Page>`
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        overflow-y: auto;

        &::-webkit-scrollbar {
            width: 10px;
        }

        &::-webkit-scrollbar-thumb {
            background: #6c5ecf;
            border-radius: 10px;
            border: 3px solid transparent;
            background-clip: padding-box;
        }

        &::-webkit-scrollbar-thumb:hover {
            border: 1px solid transparent;
        }

        &::-webkit-scrollbar-track {
            background: black;
        }
    `,
};
